// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bgf_a"};